import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/ConsentBanner';
import ScrollProgress from './components/ScrollProgress';
import Home from './pages/Home';
import Services from './pages/Services';
import Request from './pages/Request';
import Privacy from './pages/Privacy';
import Imprint from './pages/Imprint';
import Terms from './pages/Terms';
import About from './pages/About';
import Current from './pages/Current';
import References from './pages/References';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-white flex flex-col">
          <ScrollProgress />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/request" element={<Request />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/imprint" element={<Imprint />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/about" element={<About />} />
              <Route path="/current" element={<Current />} />
              <Route path="/references" element={<References />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;